// dropdown lang 

const dropdownLang=[
    
    { name: "English",icon:"en-icon",key:"en"},
    { name: "Francais",icon:"fr-icon",key:"fr"},
    { name: "Arabe",icon:"ar-icon",key:"ar"},
]
export default dropdownLang;